<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="mb-0">
      <template #prepend>
        <v-icon icon="mdi-home" size="small" />
      </template>
    </v-breadcrumbs>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card rounded="xl" elevation="2">
            <v-tabs v-model="tab" color="primary" :touch="false" hide-slider="false"
                    next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows>
              <v-tab value="parents" class="font-weight-bold"> পিতা-মাতা</v-tab>
              <v-tab value="spouse" class="font-weight-bold">
                স্বামী/স্ত্রী
              </v-tab>
              <v-tab value="children" class="font-weight-bold"> সন্তান </v-tab>
              <v-tab value="nominee" class="font-weight-bold">
                নিকটাত্মীয়
              </v-tab>
            </v-tabs>

            <v-divider />
            <v-window v-model="tab">
              <!-- Parents -->
              <v-window-item value="parents">
                <v-card-text>
                  <ParentsComponent />
                </v-card-text>
              </v-window-item>

              <!-- Spouse -->
              <v-window-item value="spouse">
                <v-card-text>
                  <SpouseComponent />
                </v-card-text>
              </v-window-item>

              <!-- Children -->
              <v-window-item value="children">
                <v-card-text>
                  <ChildrenComponent />
                </v-card-text>
              </v-window-item>

              <!-- Nominee -->
              <v-window-item value="nominee">
                <v-card-text>
                  <NomineeComponent />
                </v-card-text>
              </v-window-item>
            </v-window>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/* Components */
import ParentsComponent from "@/components/pages/PMIS/FamilyInformation/Parents.vue";
import SpouseComponent from "@/components/pages/PMIS/FamilyInformation/Spouse.vue";
import ChildrenComponent from "@/components/pages/PMIS/FamilyInformation/Children.vue";
import NomineeComponent from "@/components/pages/PMIS/FamilyInformation/Nominee.vue";

export default {
  name: "FamilyInformation",

  components: {
    ParentsComponent,
    SpouseComponent,
    ChildrenComponent,
    NomineeComponent,
  },

  data() {
    return {
      /* Active Tab */
      tab: "parents",

      /* Breadcrumb */
      breadcrumbs: [
        {
          title: "Dashboard",
          disabled: false,
          to: "/dashboard",
        },
        {
          title: "Family Information",
          disabled: true,
        },
      ],
    };
  },
};
</script>

<style scoped>
.v-tabs {
  background: transparent;
}
.v-tab {
  text-transform: none !important;
  font-size: 14px;
}
.v-window-item {
  animation: fadeSlide 0.35s ease;
}
/* Smooth Animation */
@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
